require '../../../public/main.css'

React = require 'react'

# Assign React to Window so the Chrome React Dev Tools will work.
window.React = React

Router = require('react-router')
{Route, NotFoundRoute} = Router


# Require route components.
App = require './app'

Examples = require './pages/examples'

routes = (
  React.createElement(Route, {"handler": (App)},
    React.createElement(Route, {"name": "examples", "handler": (Examples), "path": "/build", "addHandlerKey": (true)}),
    React.createElement(Route, {"name": "about", "handler": (require('./pages/aboutme')), "path": "/", "addHandlerKey": (true)}),
    React.createElement(NotFoundRoute, {"handler": (require('./pages/aboutme'))})
  )
)
Router.run(routes, (Handler) ->
  React.render React.createElement(Handler, null), document.getElementById("container")
)



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/router.cjsx
 **/